import { ProgressBar, Step } from "react-step-progress-bar";
import {
  RequestProgressBarModel,
  RequestProgressBarStepModel,
} from "./requestProgressBarModel";
import { Check2 } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

export const RequestProgressBar = ({
  stateFlow,
  size,
}: RequestProgressBarModel) => {
  const percentageFilled = (): number => {
    const total = stateFlow.length;
    const totalCompleted = stateFlow.filter((item) => item.completed).length;

    return ((totalCompleted - 1) / (total - 1)) * 100;
  };

  const backGroundLine = (): string => {
    const isCancelled =
      stateFlow.length > 0 && stateFlow[stateFlow.length - 1].cancelled;

    if (isCancelled) {
      return "linear-gradient(to right, #4caf50, #BE3723)";
    } else {
      return "#4caf50";
    }
  };

  return (
    <ProgressBar
      percent={percentageFilled()}
      filledBackground={backGroundLine()}
    >
      {stateFlow.map((step: RequestProgressBarStepModel) => {
        return (
          <Step transition="scale" key={step.value}>
            {() => (
              <div className={size == "small" ? "small" : "large"}>
                <RequestProgressBarStep
                  value={step.value}
                  completed={step.completed}
                  type={step.type}
                  cancelled={step.cancelled}
                  refused={step.refused}
                  key={step.value}
                />
              </div>
            )}
          </Step>
        );
      })}
    </ProgressBar>
  );
};

const RequestProgressBarStep = (step: RequestProgressBarStepModel) => {
  const { t } = useTranslation("common");
  const largeScreenSize = 1240;

  const mtClass = screen.width < largeScreenSize ? "mb-3" : "";

  return (
    <div className={"d-flex flex-column progress-bar-step" + " " + mtClass}>
      <div
        className={
          "circle mb-1" +
          (step.completed ? " circle-completed" : "") +
          (step.cancelled ? " circle-cancelled" : "") +
          (step.refused ? " circle-refused" : "")
        }
      >
        {(step.completed || step.cancelled || step.refused) && (
          <Check2 color={"white"} />
        )}
      </div>
      <p>{screen.width > largeScreenSize && t(step.value)}</p>
    </div>
  );
};
